@if ((isEditing$ | async) === true) {
<ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{
  model: model$ | async,
  formGroup: formGroup$ | async
}">
  </ng-container>
}

<ng-template #template let-ready="ready" let-model="model" let-formGroup="formGroup">
  <div flexLayout="column" flexLayoutAlign="start stretch">
    <formly-form [form]="formGroup" [fields]="fields" [options]="options" [model]="model">
    </formly-form>
    <div flexLayout="row" flexLayoutAlign="start center">
      @if (restrictedAccess$ | async) {
        <button mat-button
          color="warn"
          (click)="deleteTag()" type="button"
          >
          <mat-icon mat-icon-button inline>delete</mat-icon>
          Delete Tag
        </button>
      }
    </div>
  </div>
</ng-template>
